<template>
  <div class="document-style">
    <ul style="margin-block-start: 8px" class="fs-16">
      <li>
        <div class="title-list-style">
          Using Artificial Intelligence to Qualify Recognition
        </div>
        <div>
          <div class="mt-6">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Not all recognition is created
            equal. Some are more meaningful than others. At Happily, we use AI
            to help you assess the quality and meaningfulness of recognition
            given and received. Each employee is then categorized in 1 of 4
            categories for gem and coin recognition:
          </div>
        </div>
        <div class="mt-6">
          <div>
            <span class="fw-700" style="color: #f44336">Low: </span>
            <span>Does not receive a lot of this type of recognition</span>
          </div>
          <div>
            <span class="fw-700" style="color: #ef8d3a">Uptake: </span>
            <span
              >Is currently receiving an uptake (quick increase) in this type of
              recognition</span
            >
          </div>
          <div>
            <span class="fw-700" style="color: #c2e337">High: </span>
            <span
              >Receives a lot of this type of recognition (although not
              meaningful)</span
            >
          </div>
          <div>
            <span class="fw-700" style="color: #66bb6a">Super: </span>
            <span>Receives a lot of this type of recognition (meaningful)</span>
          </div>
        </div>
      </li>
      <li>
        <div class="title-list-style">Your 16 Talent Types</div>
        <div>
          <div class="mt-6">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Based on these categorizations,
            we can qualify talent into 16 different types.
          </div>
        </div>
        <div class="mt-24 flex-mid pr-40">
          <div class="network-container relative" style="min-height: 200px">
            <div class="flex">
              <div class="text-left-table">
                <div class="text" style="width: 150px; left: -24px">
                  {{ $t("insights.INDIVIDUAL_PERFORMANCE") }}
                </div>
              </div>
              <div class="grid-table">
                <div class="cell flex-mid c-FBC02D">
                  {{ $t("category.Talent_Types.Underutilized") }}
                </div>
                <div class="cell flex-mid c-C2E337">
                  {{ $t("category.Talent_Types.Activated") }}
                </div>
                <div class="cell flex-mid c-66BB6A">
                  {{ $t("category.Talent_Types.High_Performer") }}
                </div>
                <div class="cell flex-mid c-66BB6A">
                  {{ $t("category.Talent_Types.Superstar") }}
                </div>
                <div class="cell flex-mid c-EF8D3A">
                  {{ $t("category.Talent_Types.Supported") }}
                </div>
                <div class="cell flex-mid c-FBC02D">
                  {{ $t("category.Talent_Types.High_Contributor") }}
                </div>
                <div class="cell flex-mid c-C2E337">
                  {{ $t("category.Talent_Types.Core_Player") }}
                </div>
                <div class="cell flex-mid c-66BB6A">
                  {{ $t("category.Talent_Types.Solid_Performer") }}
                </div>
                <div class="cell flex-mid c-EF8D3A">
                  {{ $t("category.Talent_Types.Up_and_coming") }}
                </div>
                <div class="cell flex-mid c-EF8D3A">
                  {{ $t("category.Talent_Types.Rising_Star") }}
                </div>
                <div class="cell flex-mid c-FBC02D">
                  {{ $t("category.Talent_Types.Developing") }}
                </div>
                <div class="cell flex-mid c-C2E337">
                  {{ $t("category.Talent_Types.High_Potential") }}
                </div>
                <div class="cell flex-mid c-F44336">
                  {{ $t("category.Talent_Types.Marginalized") }}
                </div>
                <div class="cell flex-mid c-EF8D3A">
                  {{ $t("category.Talent_Types.Contributor") }}
                </div>
                <div class="cell flex-mid c-EF8D3A">
                  {{ $t("category.Talent_Types.Crowd_Favorite") }}
                </div>
                <div class="cell flex-mid c-FBC02D">
                  {{ $t("category.Talent_Types.Hidden_Talent") }}
                </div>
              </div>
            </div>
            <div class="fs-10 opa-06 pt-12 pl-32 center">
              {{ $t("insights.NETWORK_EFFECTIVENESS") }}
            </div>
          </div>
        </div>
        <div class="note-box">
          <div class="fw-700 mb-12">Reference Table</div>
          <div
            v-for="value in referenceTable"
            class="cursor-hover-table"
            style="display: grid; grid-template-columns: 30% 35% 35%"
            :key="value.talentType"
          >
            <div>{{ $t("category.Talent_Types." + value.talentType) }}</div>
            <div>{{ $t("insights." + value.individualPerformacnce) }}</div>
            <div>{{ $t("insights." + value.networkEffectiveness) }}</div>
          </div>
        </div>
        <div class="tip-box">
          <span class="note-header">Note:</span>
          <span>
            Talent is classified by frequency and quality of recognition (coins
            and gems) received. Coins are a measure of Network Effectiveness.
            Gems are a measure of Individual Performance.
          </span>
          <div class="mt-4">
            For example, an employee that receives a lot of coins from peers
            (not meaningful) but does not receive gems from their manager would
            be classified as a Crowd Favorite.
          </div>
          <div class="mt-4">
            Or an employee that is experiencing an uptake on both coins and gems
            would be classified as a Rising Star.
          </div>
        </div>
        <!-- <div class="reference">
          <div class="ref-title">Reference</div>
          <a
            class="link"
            href="https://www.notion.so/Insights-Talent-Type-EN-8dded941ece343968466954e585f4d7d"
            >Insights: Talent Type (EN)</a
          >
        </div> -->
      </li>
    </ul>
  </div>
</template>
          
<script>
export default {
  data() {
    return {
      referenceTable: [
        {
          talentType: "Marginalized",
          individualPerformacnce: "Low_Network_Effectiveness",
          networkEffectiveness: "Low_Network_Effectiveness",
        },
        {
          talentType: "Up_and_coming",
          individualPerformacnce: "Rising_Network_Effectiveness",
          networkEffectiveness: "Low_Network_Effectiveness",
        },
        {
          talentType: "Supported",
          individualPerformacnce: "High_Individual_Rating",
          networkEffectiveness: "Low_Network_Effectiveness",
        },
        {
          talentType: "Underutilized",
          individualPerformacnce: "Super_Individual_Rating",
          networkEffectiveness: "Low_Network_Effectiveness",
        },
        {
          talentType: "Contributor",
          individualPerformacnce: "Low_Network_Effectiveness",
          networkEffectiveness: "Rising_Network_Effectiveness",
        },
        {
          talentType: "Rising_Star",
          individualPerformacnce: "Rising_Network_Effectiveness",
          networkEffectiveness: "Rising_Network_Effectiveness",
        },
        {
          talentType: "High_Contributor",
          individualPerformacnce: "High_Individual_Rating",
          networkEffectiveness: "Rising_Network_Effectiveness",
        },
        {
          talentType: "Activated",
          individualPerformacnce: "Super_Individual_Rating",
          networkEffectiveness: "Rising_Network_Effectiveness",
        },
        {
          talentType: "Crowd_Favorite",
          individualPerformacnce: "Low_Network_Effectiveness",
          networkEffectiveness: "High_Network_Effectiveness",
        },
        {
          talentType: "Developing",
          individualPerformacnce: "Rising_Network_Effectiveness",
          networkEffectiveness: "High_Network_Effectiveness",
        },
        {
          talentType: "Core_Player",
          individualPerformacnce: "High_Individual_Rating",
          networkEffectiveness: "High_Network_Effectiveness",
        },
        {
          talentType: "High_Performer",
          individualPerformacnce: "Super_Individual_Rating",
          networkEffectiveness: "High_Network_Effectiveness",
        },
        {
          talentType: "Hidden_Talent",
          individualPerformacnce: "Low_Network_Effectiveness",
          networkEffectiveness: "Super_Network_Effectiveness",
        },
        {
          talentType: "High_Potential",
          individualPerformacnce: "Rising_Network_Effectiveness",
          networkEffectiveness: "Super_Network_Effectiveness",
        },
        {
          talentType: "Solid_Performer",
          individualPerformacnce: "High_Individual_Rating",
          networkEffectiveness: "Super_Network_Effectiveness",
        },
        {
          talentType: "Superstar",
          individualPerformacnce: "Super_Individual_Rating",
          networkEffectiveness: "Super_Network_Effectiveness",
        },
      ],
    };
  },
  methods: {},
};
</script><style lang="scss" scoped>
.network-container {
  $width-network-box: 96px;
  .text-left-table {
    width: 30px;
    padding-top: 112px;
    .text {
      position: absolute;
      width: 100px;
      text-align: center;
      font-size: 10px;
      margin-left: -36px;
      color: rgba(#000000, 0.6);
      transform: rotate(-90deg);
    }
  }
  .grid-table {
    width: ($width-network-box + 3px) * 4;
    display: grid;
    grid-template-columns: repeat(4, ($width-network-box)+4);
    border: 1px solid rgba(#000000, 0.2);
    border-width: 0 0 2px 2px;
    padding: 0 0 8px 12px;
    .cell {
      $padding-cell: 10px;
      margin: auto;
      width: $width-network-box - $padding-cell * 2;
      padding: 2px $padding-cell;
      height: 52px;
      margin: 0px 3px 3px 0;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 700;
      color: #fff;
      position: relative;
      display: flex;
      text-align: center;
      align-content: center;
      justify-items: center;
    }
    .cell.c-FBC02D {
      background: #fbc02d;
    }
    .cell.c-C2E337 {
      background: #c2e337;
    }
    .cell.c-66BB6A {
      background: #66bb6a;
    }
    .cell.c-EF8D3A {
      background: #ef8d3a;
    }
    .cell.c-F44336 {
      background: #f44336;
    }
    .min-of-cell-2 {
      position: absolute;
      bottom: -6px;
      width: 42px;
      z-index: 99;
    }
  }
}

.cursor-hover-table {
  transition: 0.3s;
  padding: 1px 12px;
  &:hover {
    background-color: rgba(#000000, 0.04);
  }
}
</style>